import { memo } from 'react';
import {
  Grid, Stack, Typography, Fab,
  Container,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { RoundedMedia } from '@client/components/common/Media';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { getHomePage } from '@client/selectors/features/home';
import { useFirestore } from '@client/hooks/utils.hooks';
import { upsertHome } from '@client/slices/features/home.reducer';
import { getExternalUrl } from '@sda/utils/url';

const useStyles = makeStyles()((theme) => ({
  container: {
    marginBottom: theme.spacing(4),

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(6),
    },
  },
  image: {
    borderRadius: theme.radii.large,
    boxShadow: theme.shadows[4],
    overflow: 'hidden',
  },
  imageContainer: {
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}));

export const Article = memo(() => {
  const { classes } = useStyles();
  const isMobile = useIsMobile();

  const [homePage, isLoading] = useFirestore(
    (SDK) => SDK.Settings.HomePage().get('Home'),
    {
      key: 'Home',
      selector: getHomePage,
      upserter: upsertHome,
    },
  );

  if (isLoading || !homePage?.isVisible) {
    return null;
  }

  return (
    <Container maxWidth="md">
      <div className={classes.container}>
        <Grid
          container
          spacing={isMobile ? 3 : 6}
          direction={isMobile ? 'column-reverse' : 'row'}
          alignItems="center"
        >
          <Grid
            item
            md={6}
          >
            <Typography
              variant="body2"
              color="disabled"
              gutterBottom
            >
              {homePage.categoryTitle}
            </Typography>

            <Stack spacing={2}>
              <Typography
                variant="h6"
              >
                {homePage.articleTitle}
              </Typography>

              <Typography
                variant="subtitle1"
              >
                {homePage.articleDescription}
              </Typography>

              <div>
                <Fab
                  id="sda-home-article-button"
                  className="sda-home-article-button"
                  color="info"
                  href={getExternalUrl(homePage.articleUrl)}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Read more news"
                >
                  {homePage.buttonLabel}
                </Fab>
              </div>
            </Stack>
          </Grid>

          <Grid
            item
            md={6}
            className={classes.imageContainer}
          >
            <RoundedMedia
              title="Side Door Shows"
              images={homePage.publicImageUrl}
              className={classes.image}
              enableCarousel
            />
          </Grid>
        </Grid>
      </div>
    </Container>
  );
});
